import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrdersService } from '../../services/orders/orders.service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';

@Component({
  selector: 'app-unconfirm-with-reason',
  templateUrl: './unconfirm-with-reason.component.html',
  styleUrls: ['./unconfirm-with-reason.component.scss']
})
export class UnconfirmWithReasonComponent implements OnInit {

  data:any={};
  userId: any;
  @Input() OrderId: any;
  @Input() Type: any;
  @Output() onCloseBtnClick = new EventEmitter<any>();
  @Output() CallUnconfirmApi = new EventEmitter<any>();

  Reason: any = {
    lable: 'Change Reason',
    formControlName: 'Reason',
    dataField: 'Reason',
    isRequired: true,
    placeholder: 'Select Reason',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  
  constructor(
      private orderService: OrdersService,
      private _appService: appService,
      private toastr: ToastrService,
      private decryptpipe: DecryptPipe,
      private cookieService: CookieService,
  ) { }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
  }

  getChangedValue(value, data) {
    if (value) {
      this.data[data.dataField] = value.value;
    }else{
      this.data[data.dataField] = null;
    }
  }
  
  GetReasonList(value, isScrollDown = false) {
    this.Reason.isSearch = true;
    let type = 'Order'
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Reason.dropdownList.length / 20) + 1;
    }
    this.orderService.ReasonSelect2(value, pageNo, type).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Reason.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Reason.dropdownList);
        this.Reason = { ...this.Reason, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Reason = { ...this.Reason, dropdownList: [...dropdownList] });
      this.Reason.isSearch = false;
    }).catch(error => {
      this.Reason.isSearch = false;
    })
  }

  closeModal() {
    this.onCloseBtnClick.emit();
  }


  UnconfirmOrder() {
  if (!this.data.Reason) {
    this.toastr.warning('Please select reason first', 'Warning');
    return;
  }

  this.CallUnconfirmApi.emit(this.data);
}

executeUnconfirm(reasonData: any) {
  this.data = {
    ...reasonData,
    CreatedBy: this.userId,
    OrderId: this.OrderId,
    Type: this.Type
  };

  this._appService.Post("OrdersByVehicle", "save_UnconfirmOrderHistory", this.data)
    .subscribe(
      (response) => {
        // this.toastr.success("Order unconfirmed successfully");
        this.onCloseBtnClick.emit();
      },
      (err) => {
        console.error(err._body.replace(/"/g, ""), "error");
      }
    );
}


  // UnconfirmOrder(){
  //   if(!this.data.Reason){
  //     this.toastr.warning('Please select reason first','Warning');
  //     return;
  //   }

  //   this.data.CreatedBy = this.userId;
  //   this.data.OrderId = this.OrderId;
  //   this.data.Type = this.Type;
  //   this._appService.Post("OrdersByVehicle", "save_UnconfirmOrderHistory", this.data).subscribe(
  //     (response) => {
  //       this.CallUnconfirmApi.emit(true);
  //       this.onCloseBtnClick.emit();
  //     },
  //     (err) => {
  //       console.error(err._body.replace(/"/g, ""), "error");
  //     }
  //   );
    
  //   console.log(this.data);
  // }
}
